import http from "../utils/http-common";

const baseTransportationMarketPath = "api/transportation-marketing";

// Setup Loading Information
export const getYear = (companyId: string) => {
  return http.get(`${baseTransportationMarketPath}/year/${companyId}`);
};

export const getOptions = (companyId: string, year: number) => {
  return http.get(`${baseTransportationMarketPath}/options/filter-transportation-marketing/${companyId}/${year}`);
};

export const getLoadingInform = (companyId: string, query: string) => {
  return http.get(`${baseTransportationMarketPath}/loading-information/${companyId}?${query}`);
};

export const deleteLoadingInformById = (companyId: string, id: string) => {
  return http.delete(`${baseTransportationMarketPath}/loading-information/${companyId}/${id}`);
};

export const createLoadingInformation = (data: any) => {
  return http.post(`${baseTransportationMarketPath}/loading-information`, data);
};

export const updateLoadingInformation = (id: string, data: any) => {
  return http.patch(`${baseTransportationMarketPath}/loading-information/${id}`, data);
};

// Manual Chemical Volume
export const getChemicalVolume = (companyId: string, query: string) => {
  return http.get(`${baseTransportationMarketPath}/manual/chemical-volume/${companyId}?${query}`);
};

export const updateChemicalVolume = (id: string, data: any) => {
  return http.patch(`${baseTransportationMarketPath}/manual/chemical-volume/${id}`, data);
};

export const getOptionsChemicalVolume = (companyId: string, year: number) => {
  return http.get(`${baseTransportationMarketPath}/manual/chemical-volume/options/filter-chemical-volume/${companyId}/${year}`);
};

// Report Chemical Volume
export const getReportChemicalVolume = (companyId: string, query: string) => {
  return http.get(`${baseTransportationMarketPath}/report/chemical-volume/${companyId}?${query}`);
};

// Report Voc Emission
export const getReportVocEmission = (companyId: string, query: string) => {
  return http.get(`${baseTransportationMarketPath}/report/voc-emission/${companyId}?${query}`);
};

export const getOptionMonthSubmit = (companyId: string, year: number) => {
  return http.get(`${baseTransportationMarketPath}/report/voc-emission/approve/month/${companyId}/${year}`);
};

export const getOptionVocApprove = (companyId: string) => {
  return http.get(`${baseTransportationMarketPath}/report/voc-emission/approve/filter-voc-approve/${companyId}`);
};

export const submitReportVoc = (companyId: string, data: any) => {
  return http.post(`${baseTransportationMarketPath}/report/voc-emission/approve/submit-report/${companyId}`, data);
};

export const getInfoStepApprove = (companyId: string, approveId: string) => {
  return http.get(`${baseTransportationMarketPath}/report/voc-emission/approve/info-step/${companyId}/${approveId}`);
};

export const updateApproveStep = (companyId: string, data: any) => {
  return http.patch(`${baseTransportationMarketPath}/report/voc-emission/approve/approve-step/${companyId}`, data);
};

export const calculateReportVocEmission = (id: string) => {
  return http.post(`${baseTransportationMarketPath}/report/voc-emission/calculate/${id}`);
};

export const calculateReportVocEmissionMasterChange = (query: { chemicalId: string; loadingById: string; emissionControlId: string }) => {
  return http.post(`${baseTransportationMarketPath}/report/voc-emission/calculate/change-master`, query);
};
